import FooterContainer from './footer.container';
import structure from './footer.structure';

export default FooterContainer;
export {
    structure
};
